import { AuthLayout } from "layout";
import { PaymentStatusPage } from "pages/admin";
import { LoginPage } from "pages/admin/auth";
import { redirect, RouteObject } from "react-router-dom";

export const authAdminRouter: RouteObject[] = [
  {
    path: "*",
    loader() {
      return redirect(process.env.NODE_ENV === "production" ? "auth/login" : "admin/auth/login");
    },
  },
  {
    path: process.env.NODE_ENV === "production" ? "auth" : "admin/auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <LoginPage />,
      }
    ],
  },
  {
    path: "payment-status",
    element: <PaymentStatusPage />,
  },
];
